import liveBoxes from './articles/live-boxes';
import presetChangeRequest from './articles/preset-change-request';
import rawQcBayDecision from './articles/raw-qc-bay-decision';
import rawQcPerformance from './articles/raw-qc-performance';
import liveShootBayFilter from './articles/live-shoot-bay-filter';
import orderCsvStatus from './articles/order-csv-status';
import processReports from './articles/process-reports';
import rejections from './articles/rejections';
import bulkSkuRequests from './articles/bulk-sku-requests';
import changeOrder from './articles/change-order';
import skuScanHistory from './articles/sku-scan-history';
import studioFloorPages from './articles/studio-floor-pages';
import mergedGuidelineTeamLead from './articles/merged-guideline-team-lead';
import piiKeys from './articles/pii-keys';
import planningBayAssign from './articles/planning-bay-assign';
import workTracker from './articles/work-tracker';
import productVariantFields from './articles/product-variant-fields';

const articles = [
    liveBoxes,
    presetChangeRequest,
    rawQcBayDecision,
    rawQcPerformance,
    liveShootBayFilter,
    orderCsvStatus,
    processReports,
    rejections,
    bulkSkuRequests,
    skuScanHistory,
    studioFloorPages,
    mergedGuidelineTeamLead,
    piiKeys,
    changeOrder,
    planningBayAssign,
    workTracker,
    productVariantFields,
];

export const getNewsArticles = () =>
    [...articles].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt));

export const getNewsArticleById = (id) => getNewsArticles().find((a) => a.id === id);
